module.exports = __webpack_public_path__ + "img/HomePage-innovation.8998cf5.webp";